import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=3b98028e&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=3b98028e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98028e",
  null
  
)

export default component.exports